import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => {
  return {
    avatarGrid: {
      alignSelf: 'center',
      marginBottom: theme.spacing(1.25),
    },
    avatarBlock: {
      width: 120,
      height: 120,
      fontSize: 38,
    },
    nameGrid: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    divider: {
      width: '100%',
      marginTop: theme.spacing(0.75),
      marginBottom: theme.spacing(0.75),
    },
  }
})
